var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceImupset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    fill: "#FF7676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.225 142.001C128.184 141.836 128.14 141.668 128.092 141.496C127.477 127.888 112.723 117.001 94.6118 117.001C76.5007 117.001 61.7463 127.889 61.1317 141.496C61.0839 141.668 61.0398 141.836 60.9991 142.001H61.1155C61.1187 141.832 61.1242 141.664 61.1317 141.496C62.9678 134.892 70.1766 123.049 94.6119 123.049C119.047 123.049 126.256 134.891 128.092 141.496C128.099 141.663 128.105 141.832 128.108 142.001H128.225Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.666 45.0814C129.633 45.1468 129.6 45.2144 129.567 45.2841C125.657 50.0443 128.608 57.1528 136.329 61.3425C144.049 65.5323 153.677 65.2503 158.111 60.7744C158.184 60.727 158.255 60.6799 158.323 60.6334L158.273 60.6063C158.22 60.663 158.166 60.719 158.111 60.7744C155.303 62.591 148.599 64.9426 138.183 59.2898C127.767 53.637 128.325 47.9502 129.567 45.2841C129.616 45.2251 129.665 45.1666 129.716 45.1084L129.666 45.0814Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 60.552C31.0681 60.5986 31.1388 60.6458 31.2122 60.6932C35.6463 65.1691 45.274 65.4511 52.9943 61.2613C60.7146 57.0715 63.6655 49.963 59.7554 45.2028C59.7229 45.1331 59.69 45.0655 59.6568 45L59.607 45.027C59.6575 45.0852 59.707 45.1438 59.7554 45.2028C60.9976 47.8688 61.5558 53.5558 51.1397 59.2086C40.7237 64.8613 34.0198 62.5098 31.2122 60.6932C31.1573 60.6378 31.1031 60.5817 31.0498 60.525L31 60.552Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.334 79.1424C76.5951 76.6171 69.005 76.676 62.2825 79.2923C55.5599 81.9087 52.2276 86.1007 54.7704 88.7024L79.334 79.1424Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6602 79.0775C78.5102 75.534 71.865 71.866 64.7228 70.8524C57.5807 69.8388 52.6216 71.86 53.5633 75.374L79.6602 79.0775Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.182 79.1419C112.952 76.6166 120.629 76.6756 127.428 79.2919C134.228 81.9082 137.598 86.1002 135.027 88.7019L110.182 79.1419Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.852 79.0775C111.015 75.534 117.736 71.8659 124.96 70.8523C132.184 69.8387 137.2 71.86 136.247 75.374L109.852 79.0775Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceImupset);
export default __webpack_public_path__ + "static/media/Face_Im upset.fd102aa73e5211b82d126f3cfdea8799.svg";
export { ForwardRef as ReactComponent };